export const SET_CURRENT_SENSOR = 'SET_CURRENT_SENSOR'

export const setCurrentSensor = (sensorId) => ({
  type: SET_CURRENT_SENSOR,
  payload: sensorId,
})
